module.exports = __webpack_public_path__ + "static/media/jafar.197067a5.jpg";